import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M7.494 1.75C4.044 1.75 1.25 4.55 1.25 8s2.794 6.25 6.244 6.25c3.456 0 6.256-2.8 6.256-6.25s-2.8-6.25-6.256-6.25M7.5 13c-2.762 0-5-2.238-5-5s2.238-5 5-5 5 2.238 5 5-2.238 5-5 5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M7.813 4.875h-.938v3.75l3.281 1.969.469-.769-2.812-1.669z"
    }, null, -1)
  ])))
}
export default { render: render }